import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { layout } from 'app/styles';
import * as commentActions from 'modules/comment/comment.actions';
import * as investActions from 'modules/post/invest.actions';
import * as createPostActions from 'modules/createPost/createPost.actions';
import * as animationActions from 'modules/animation/animation.actions';
import { BodyText, Box, View, Spacer } from 'modules/styled';
import CommentForm from './commentForm.component';
import Comment from './comment.component';

class Comments extends Component {
  static propTypes = {
    actions: PropTypes.object,
    match: PropTypes.object,
    comments: PropTypes.object,
    posts: PropTypes.object,
    auth: PropTypes.object,
    post: PropTypes.object,
    myPostInv: PropTypes.object,
    user: PropTypes.object,
    screenSize: PropTypes.number,
  };

  state = {
    activeComment: null,
  };

  setActiveComment = (commentId) => {
    const activeComment = this.state.activeComment === commentId ? null : commentId;
    this.setState({ activeComment });
  };

  scrollTo = (x, y) => {
    const paddingY = window.outerHeight / 4;
    window.scrollTo(x, y - paddingY);
  };

  scrollToBottom() {
    window.scrollTo(0, document.body.scrollHeight);
  }

  renderComment = ({ comment, additionalNesting, focusedComment, orphan = false }) => {
    const { comments, posts, post, myPostInv, user, screenSize } = this.props;
    return (
      <Comment
        comment={comment}
        myPostInv={myPostInv}
        user={user}
        activeComment={this.state.activeComment}
        setActiveComment={this.setActiveComment}
        childComments={comments.childComments}
        posts={posts}
        parentPost={post}
        nestingLevel={additionalNesting}
        focusedComment={focusedComment}
        scrollTo={this.scrollTo}
        screenSize={screenSize}
        orphan={orphan}
      />
    );
  };

  render() {
    const { comments, posts, post, match, screenSize } = this.props;
    const children = comments.childComments?.[post._id] || [];
    const orphans = comments.orphans?.[post._id] || [];
    const focusedComment = match?.params?.commentId;
    const additionalNesting = screenSize ? 0 : layout.POST_BUTTONS_NESTING_UNITS;

    return (
      <Box>
        <CommentForm
          nestingLevel={0}
          additionalNesting={screenSize ? 0 : layout.POST_BUTTONS_NESTING_UNITS}
          buttonText={'Comment'}
          parentPost={post}
          sx={{ p: [2, 4], pt: [4, 0] }}
        />
        {children.length !== 0 ? (
          <Box>
            {children.map((id) => {
              const comment = posts.posts[id];
              if (!comment) return null;
              return (
                <View key={id}>
                  {this.renderComment({ comment, additionalNesting, focusedComment })}
                </View>
              );
            })}
          </Box>
        ) : null}
        {orphans.length !== 0 ? (
          <Box>
            {orphans.map((id) => {
              const comment = posts.posts[id];
              if (!comment) return null;
              return (
                <View key={id}>
                  {this.renderComment({
                    comment,
                    additionalNesting,
                    focusedComment,
                    orphan: true,
                  })}
                </View>
              );
            })}
          </Box>
        ) : null}
      </Box>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      auth: state.auth,
      comments: state.comments,
      myPostInv: state.investments.myPostInv,
      user: state.user,
      screenSize: state.navigation.screenSize,
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...commentActions,
          ...createPostActions,
          ...investActions,
          ...animationActions,
        },
        dispatch
      ),
    })
  )(Comments)
);
